import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import { getApiUrl, setApiUrl } from '../config/api';

const GlobalIpModal = ({ show, onHide, onSaveSuccess }) => {
  const [ipUrl, setIpUrl] = useState('');
  const [savedSuccess, setSavedSuccess] = useState(false);

  useEffect(() => {
    if (show) {
      setIpUrl(getApiUrl());
      setSavedSuccess(false);
    }
  }, [show]);

  const handleSave = (e) => {
    if (e) e.preventDefault();
    const formatted = setApiUrl(ipUrl);
    setSavedSuccess(true);

    if (onSaveSuccess) {
      onSaveSuccess(formatted);
    }

    setTimeout(() => {
      onHide();
      window.location.reload();
    }, 600);
  };

  const handlePreset = (presetUrl) => {
    setIpUrl(presetUrl);
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)', color: '#fff' }}>
        <Modal.Title style={{ fontSize: '0.95rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
          <i className="bi bi-hdd-network-fill text-warning fs-5"></i>
          <span>PENGATURAN GLOBAL IP SERVER BACKEND</span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ background: '#f8fafc', padding: '1.25rem' }}>
        <p className="text-muted" style={{ fontSize: '0.78rem' }}>
          Atur Alamat IP / URL Server Backend secara global. Semua modul aplikasi (User Management, Group User, Permission, Master Data, SP, Stok) akan otomatis menggunakan IP ini.
        </p>

        {savedSuccess && (
          <div className="alert alert-success d-flex align-items-center gap-2 py-2 mb-3" style={{ fontSize: '0.8rem' }}>
            <i className="bi bi-check-circle-fill fs-6 text-success"></i>
            <span>IP Server Backend berhasil disimpan & diterapkan secara global! Memuat ulang...</span>
          </div>
        )}

        <Form onSubmit={handleSave}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold text-dark" style={{ fontSize: '0.8rem' }}>
              Alamat IP / URL Server Backend:
            </Form.Label>
            <InputGroup size="sm">
              <InputGroup.Text style={{ background: '#e2e8f0', color: '#0f172a', fontWeight: '600' }}>
                <i className="bi bi-link-45deg"></i>
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Contoh: http://202.155.94.169:7000"
                value={ipUrl}
                onChange={(e) => setIpUrl(e.target.value)}
                style={{ fontSize: '0.82rem', fontWeight: '600', color: '#0369a1' }}
                required
              />
            </InputGroup>
          </Form.Group>

          {/* Quick Presets */}
          <div className="mb-3">
            <div className="text-muted mb-1.5 fw-semibold" style={{ fontSize: '0.7rem' }}>Pilihan Preset Cepat:</div>
            <div className="d-flex gap-1.5 flex-wrap">
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() => handlePreset('http://202.155.94.169:7000')}
                className="rounded-pill px-2.5 py-0.5"
                style={{ fontSize: '0.7rem' }}
              >
                🌐 Server Utama (202.155.94.169:7000)
              </Button>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => handlePreset('http://localhost:8000')}
                className="rounded-pill px-2.5 py-0.5"
                style={{ fontSize: '0.7rem' }}
              >
                💻 Server Lokal (localhost:8000)
              </Button>
            </div>
          </div>

          <div className="p-2.5 rounded-3 mb-2" style={{ background: '#e0f2fe', border: '1px solid #bae6fd', fontSize: '0.73rem', color: '#0369a1' }}>
            <i className="bi bi-info-circle-fill me-1"></i>
            IP Server yang aktif saat ini: <strong>{getApiUrl()}</strong>
          </div>
        </Form>
      </Modal.Body>

      <Modal.Footer style={{ background: '#f1f5f9', borderTop: '1px solid #e2e8f0' }}>
        <Button variant="secondary" size="sm" onClick={onHide} style={{ fontSize: '0.78rem' }}>
          Batal
        </Button>
        <Button variant="teal" size="sm" onClick={handleSave} style={{ background: '#0d9488', borderColor: '#0d9488', color: '#fff', fontSize: '0.78rem', fontWeight: '600' }}>
          <i className="bi bi-save me-1"></i>Simpan & Terapkan IP
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GlobalIpModal;
